// Customer Configuration
// Update these values for each customer deployment

import { getActiveSector } from '../hooks/useActiveSector';

const IS_DEMO = import.meta.env.VITE_DEMO_MODE === 'true';

function pickApiKey(): string {
  if (IS_DEMO) {
    const sector = getActiveSector();
    switch (sector.key) {
      case 'perakende':
        return import.meta.env.VITE_DEMO_PERAKENDE_API_KEY || '';
      case 'toptan':
        return import.meta.env.VITE_DEMO_TOPTAN_API_KEY || '';
      case 'restoran':
        return import.meta.env.VITE_DEMO_RESTORAN_API_KEY || '';
    }
  }
  return import.meta.env.VITE_API_KEY || 'rg_api_XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX';
}

// `??` (not `||`) so that `VITE_API_URL=` (empty string in .env.local) is
// honored — empty base means relative requests, which the dev-server proxy
// (`/api → api.raporgor.com`) can intercept to bypass CORS during local QA.
export const API_URL = import.meta.env.VITE_API_URL ?? 'https://api.raporgor.com';
export const API_KEY = pickApiKey();
export const CUSTOMER_NAME = import.meta.env.VITE_CUSTOMER_NAME || 'Müşteri Paneli';

// Source IDs - Update for each customer
export const SOURCES = {
  KASA_RAPORU: 12,
  // Add more sources as needed
} as const;

// Theme configuration
export const THEME = {
  primaryColor: '#1890ff',
  headerColor: '#001529',
} as const;
